import * as Yup from "yup";
import { countryLabels } from "@/constant/countries";
import {
  textFieldValidation,
  emailValidation,
  imageValidation,
  phoneNumberValidation,
} from "./validations";

// Validation schema for edit mode, including DMO Admin fields
export const userValidationSchema = Yup.object().shape({
  userName: textFieldValidation("Name", 2, 50, true),
  userGmail: emailValidation(true),
  role: Yup.array()
    .min(1, "At least one role is required")
    .required("Role is required"),
  organization: Yup.string().notRequired(),
  status: Yup.string()
    .oneOf(["Active", "Inactive"], "Invalid status")
    .required("Status is required"),
  profilePicture: imageValidation(false, 5),
  countryCode: Yup.string()
    .matches(/^\+\d{1,3}$/, "Invalid country code (e.g., +1, +91)")
    .required("Country code is required"),
  countryShortCode: Yup.string().oneOf(
    Object.keys(countryLabels),
    "Invalid country short code",
  ),
  phoneCountryShortCode: Yup.string()
    .oneOf(["", ...Object.keys(countryLabels)], "Invalid country short code")
    .notRequired()
    .nullable(),
  phoneNumber: phoneNumberValidation("Phone number", false, "phoneCountryShortCode"),
  nationality: Yup.string().oneOf(
    ["", ...Object.keys(countryLabels)],
    "Invalid nationality",
  ),
  userCountryCode: Yup.string().oneOf(
    ["", ...Object.keys(countryLabels)],
    "Invalid country",
  ),
});

// Validation schema for create user
export const createUserValidationSchema = Yup.object().shape({
  userType: Yup.array()
    .min(0, "At least one role is required")
    .required("Role is required"),
  name: textFieldValidation("Name", 2, 50, true),
  countryCode: Yup.string()
    .matches(/^\+\d{1,3}$/, "Invalid country code (e.g., +1, +91)")
    .required("Country code is required"),
  countryShortCode: Yup.string().oneOf(
    Object.keys(countryLabels),
    "Invalid country short code",
  ),
  phoneCountryShortCode: Yup.string()
    .oneOf(["", ...Object.keys(countryLabels)], "Invalid country short code")
    .notRequired()
    .nullable(),
  phoneNumber: phoneNumberValidation("Phone number", false, "phoneCountryShortCode"),
  nationality: Yup.string().oneOf(
    ["", ...Object.keys(countryLabels)],
    "Invalid nationality",
  ),
  userCountryCode: Yup.string().oneOf(
    ["", ...Object.keys(countryLabels)],
    "Invalid country",
  ),
  email: emailValidation(true),
  profilePicture: imageValidation(false, 5),
});
